module.exports = __webpack_public_path__ + "img/Logo-4.8df786cd.svg";